<template>
  <div class="workInformation">
    <el-form
      label-position="left"
      :model="form"
      label-width="74px"
      style="width: 100%"
      :rules="rules"
      ref="dynamicValidateForm"
    >
      <div class="workInformationTop">
        <el-form-item label="作品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入..."></el-input>
        </el-form-item>
        <el-form-item label="作品类型" prop="type">
          <el-select
            class="elSelectBlock"
            v-model="form.type"
            placeholder="请输入..."
          >
            <el-option
              v-for="(item, index) in worksList"
              :key="index"
              :label="item.name"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作品封面">
          <div class="coverContainer">
            <div class="left_">
              <input type="file" @change="inputFile($event, 'poster')" />
              <img :src="poster" v-if="poster" />
              <img src="@/assets/images/contentChainCover.png" v-else />
            </div>
            <div class="right_">
              <div>有值得封面有利于推荐、格式知识jepg、png</div>
              <div>大小不超过2M</div>
            </div>
          </div>
          <!-- <div class="el-form-item__error" v-if="!poster">请上传作品封面</div> -->
        </el-form-item>
        <el-form-item label="作品样本">
          <div class="aSample">
            <div class="top">
              <div class="uploadWap">
                上传
                <input type="file" @change="uploadFilePath($event, 'Z1')" />
              </div>
              <div class="uploadOk" v-if="uploadShow.Z1">上传成功!</div>
              <div class="el-form-item__error" v-if="!uploadShow.Z1">
                请先完成上传
              </div>
            </div>

            <div class="bottom">
              请上传word、pdf、jpg、png、jpeg格式，且文件大小在200m以内的文件
            </div>
          </div>
        </el-form-item>
        <el-form-item label="作品性质" prop="creation">
          <div class="creativeNature">
            <div class="typelist">
              <div
                v-for="(item, index) in typeList"
                :key="index"
                :class="item.type == form.creation ? 'active' : ''"
                @click="typeListClick(item)"
              >
                {{ item.name }}
              </div>
              <div style="width: 102px; height: 0"></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="creativeNature">
            <!-- <div class="illustrations">
              <div>请上传jpg、png、jepg、pdf、word格式，上传签章原件</div>
            </div> -->
            <div class="forImgWap">
              <div class="itemList">
                <div class="theTitle">作品创作说明</div>
                <div class="theImg">
                  <input type="file" @change="uploadFilePath($event, 'C1')" />
                  <img
                    src="@/assets/images/uploadOk.jpg"
                    v-if="uploadShow.C1"
                  />
                  <img
                    src="@/assets/images/contentChainInstructions.png"
                    v-else
                  />
                </div>
                <div class="theFont">
                  请上传jpg、png、jpeg、pdf、word格式，上传签章原件
                </div>
                <div class="downloadTemplate" @click="dowmloadMth('C1')">
                  下载模板（仅供参考）
                </div>
                <div class="el-form-item__error" v-if="!uploadShow.C1">
                  请上传作品创作说明
                </div>
              </div>
            </div>
            <div class="illustrations">
              <div>请上传jpg、png、jepg、pdf、word格式，上传签章原件</div>
            </div>
            <div class="forImgWap">
              <div class="itemList">
                <div class="theTitle">作品权利保证书</div>
                <div class="theImg">
                  <input type="file" @change="uploadFilePath($event, 'C3')" />
                  <img
                    src="@/assets/images/uploadOk.jpg"
                    v-if="uploadShow.C3"
                  />
                  <img src="@/assets/images/C3.png" v-else />
                </div>
                <div class="theFont">
                  请上传jpg、png、jpeg、pdf、word格式，上传签章原件
                </div>
                <div class="downloadTemplate" @click="dowmloadMth('C3')">
                  下载模板（仅供参考）
                </div>
                <div class="el-form-item__error" v-if="!uploadShow.C3">
                  请上传作品权利保证书
                </div>
              </div>

              <div class="itemList">
                <div class="theTitle">作品创作过程证明（选填）</div>
                <div class="theImg">
                  <input type="file" @change="uploadFilePath($event, 'C2')" />
                  <img
                    src="@/assets/images/uploadOk.jpg"
                    v-if="uploadShow.C2"
                  />
                  <img src="@/assets/images/C2.png" v-else />
                </div>
                <div class="theFont"></div>
              </div>

              <div class="itemList">
                <div class="theTitle">著作权许可使用合同</div>
                <div class="theImg">
                  <input type="file" @change="uploadFilePath($event, 'C8')" />
                  <img
                    src="@/assets/images/uploadOk.jpg"
                    v-if="uploadShow.C8"
                  />
                  <img src="@/assets/images/contentChainUpload3.png" v-else />
                </div>
                <div class="theFont">
                  作品的创作性质，为改编/翻译/汇编/注释/整理/其他时，必填
                </div>
                <div
                  class="el-form-item__error"
                  v-if="!uploadShow.C8 && form.creation"
                >
                  请上传著作权许可使用合同
                </div>
              </div>

              <div class="itemList">
                <div class="theTitle">唯一著作权平台承诺书</div>
                <div class="theImg">
                  <input type="file" @change="uploadFilePath($event, 'C16')" />
                  <img
                    src="@/assets/images/uploadOk.jpg"
                    v-if="uploadShow.C16"
                  />
                  <img src="@/assets/images/contentChainUpload4.png" v-else />
                </div>
                <div class="theFont">
                  请上传jpg、png、jpeg、pdf、word格式，上传签章原件
                </div>
                <div class="downloadTemplate" @click="dowmloadMth('C16')">
                  下载模板（仅供参考）
                </div>
                <div class="el-form-item__error" v-if="!uploadShow.C16">
                  请上传唯一著作权平台承诺书
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>

      <div class="itemBorderWap">
        <div class="itemBorder">
          <el-form-item label="创作时间" prop="worksCreateTime">
            <el-date-picker
              v-model="form.worksCreateTime"
              type="date"
              style="width: 100%"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="创作地点" prop="worksCreationCity">
            <div class="selectFourWap">
              <div>
                <el-input
                  v-model="form.worksCreationCountry"
                  placeholder="国家"
                ></el-input>
              </div>
              <div>
                <el-input
                  v-model="form.worksCreationCity"
                  placeholder="市"
                ></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="发表状态" prop="worksPublishStatus">
            <el-radio-group v-model="form.worksPublishStatus">
              <el-radio border :label="0">未发表</el-radio>
              <el-radio border :label="1">已发表</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="itemBorderWap" v-if="form.worksPublishStatus == '1'">
        <div class="itemBorder">
          <el-form-item label="发表日期" prop="worksPublishTime">
            <el-date-picker
              v-model="form.worksPublishTime"
              type="date"
              style="width: 100%"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="发表地点" prop="worksPublishCity">
            <div class="selectFourWap">
              <div>
                <el-input
                  v-model="form.worksPublishCountry"
                  placeholder="国家"
                ></el-input>
              </div>
              <div>
                <el-input
                  v-model="form.worksPublishCity"
                  placeholder="市"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>

      <div class="itemBorderWap" v-if="form.worksPublishStatus == '1'">
        <div class="itemBorder">
          <el-form-item label="出版日期">
            <el-date-picker
              v-model="form.worksComeoutDate"
              type="date"
              style="width: 100%"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="出版地点">
            <div class="selectFourWap">
              <div>
                <el-input
                  v-model="form.worksComeoutCountry"
                  placeholder="国家"
                ></el-input>
              </div>
              <div>
                <el-input
                  v-model="form.worksComeoutCity"
                  placeholder="市"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>

      <div class="itemBorderWap" v-if="form.worksPublishStatus == '1'">
        <div class="itemBorder">
          <el-form-item label="发行时间">
            <el-date-picker
              v-model="form.worksIssueDate"
              type="date"
              style="width: 100%"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="发行地点">
            <div class="selectFourWap">
              <div>
                <el-input
                  v-model="form.worksIssueCountry"
                  placeholder="国家"
                ></el-input>
              </div>
              <div>
                <el-input
                  v-model="form.worksIssueCity"
                  placeholder="市"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="editorWap">
        <div class="title">作品内容</div>

        <div class="content" v-if="form.content">
          <quillEditor :modelValue="form.content" @setContent="setContent" />
          <!-- <quillEditor v-else :modelValue="form.content" @setContent="setContent"/> -->
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import Cookies from "js-cookie";

import quillEditor from "@/components/quillEditor";
// import quillEditor from "@/components/editor";
import { ElMessage } from "element-plus";
import {
  uploadFilePath,
  articleGetWorksInfo,
  articleUploadDETTwo,
} from "../../api/interfaceList.js";

export default {
  name: "workInformation",
  components: {
    quillEditor,
  },
  data() {
    return {
      rules: {
        name: [
          { required: true, message: "作品名称不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择作品类别", trigger: "change" },
        ],
        creation: [
          { required: true, message: "请选择作品性质", trigger: "blur" },
        ],
        worksCreateTime: [
          { required: true, message: "请选择日期", trigger: "blur" },
        ],
        worksCreationCity: [
          { required: true, message: "请填写地点", trigger: "blur" },
        ],
        worksPublishStatus: [
          { required: true, message: "请选择发表状态", trigger: "change" },
        ],
        worksPublishTime: [
          { required: true, message: "请输入发表时间", trigger: "blur" },
        ],
        worksPublishCity: [
          { required: true, message: "请选择发表地点", trigger: "blur" },
        ],
      },
      uploadShow: {
        C1: false,
        C2: false,
        C3: false,
        Z1: false,
        C8: false,
        C16: false,
      },
      worksList: [
        {
          type: 1,
          name: "文字",
        },
        {
          type: 2,
          name: "口述",
        },
        {
          type: 3,
          name: "音乐",
        },
        {
          type: 4,
          name: "戏剧",
        },
        {
          type: 5,
          name: "曲艺",
        },
        {
          type: 6,
          name: "舞蹈",
        },
        {
          type: 7,
          name: "杂技",
        },
        {
          type: 8,
          name: "美术",
        },
        {
          type: 9,
          name: "建筑",
        },
        {
          type: 10,
          name: "摄影",
        },
        {
          type: 11,
          name: "电影",
        },
        {
          type: 12,
          name: "类似摄制电影方法创作作品",
        },
        {
          type: 13,
          name: "工程设计图,产品设计图",
        },
        {
          type: 15,
          name: "地图,示意图",
        },
        {
          type: 17,
          name: "模型",
        },
        {
          type: 19,
          name: "录音作品",
        },
        {
          type: 20,
          name: "录像作品",
        },
        {
          type: 181,
          name: "其他作品",
        },
      ],
      form: {
        name: "",
        type: "",
        creation: "",
        worksCreateTime: "",
        worksCreationCountry: "",
        worksCreationCity: "",
        worksPublishStatus: "",
        worksPublishTime: "",
        worksPublishCountry: "",
        worksPublishCity: "",
        worksComeoutDate: "",
        worksComeoutCountry: "",
        worksComeoutCity: "",
        worksIssueDate: "",
        worksIssueCountry: "",
        worksIssueCity: "",
        content: "",
      },
      typeList: [
        {
          name: "原创",
          type: 0,
        },
        {
          name: "改编",
          type: 1,
        },
        {
          name: "翻译",
          type: 2,
        },
        {
          name: "汇编",
          type: 3,
        },
        {
          name: "注释",
          type: 4,
        },
        {
          name: "整理",
          type: 5,
        },
        {
          name: "其他",
          type: 6,
        },
      ],
      formData: new FormData(),
      filesData: new FormData(),
      contentUniqueCode: "",
      poster: "",
    };
  },
  props: ["publicData"],
  computed: {
    personalType() {
      return this.publicData.personalType;
    },
  },
  watch: {
    personalType() {
      this.articleUploadDETTwo();
    },
  },
  mounted() {
    this.articleGetWorksInfo();
  },
  methods: {
    articleUploadDETTwo() {
      setTimeout(() => {
        let isOk = document.getElementsByClassName("el-form-item__error")[0];
        console.log(isOk);
        if (!isOk) {
          if (this.form.worksPublishStatus == 0) {
            delete this.form.worksPublishTime;
            delete this.form.worksPublishCountry;
            delete this.form.worksPublishCity;
            delete this.form.worksComeoutDate;
            delete this.form.worksComeoutCountry;
            delete this.form.worksComeoutCity;
            delete this.form.worksIssueDate;
            delete this.form.worksIssueCountry;
            delete this.form.worksIssueCity;
          }
          for (var key in this.form) {
            if (this.form[key] || key == 0) {
              this.formData.append(key, this.form[key]);
            }
          }
          this.formData.append(
            "worksPublishStatus",
            this.form.worksPublishStatus
          );
          this.formData.append("creation", this.form.creation);
          this.formData.append("uniqueCode", this.contentUniqueCode);
          articleUploadDETTwo(this.formData).then((res) => {
            if (res.code == 1) {
              // ElMessage({
              //   message: res.message,
              //   type: "success",
              // });
              let json = {
                key: 2,
                isOk: true,
              };
              this.$emit("isOk", json);
            } else {
              ElMessage({
                message: "参数错误或不完整",
                type: "warning",
              });
            }
            this.poster = "";
            this.formData = new FormData();
          });
        } else {
          let isgo = this.$refs["dynamicValidateForm"].validate.length;
          if (isgo) {
            this.$refs["dynamicValidateForm"].validate(() => {
              console.log("isOk");
              // setTimeout(() => {
              document
                .getElementsByClassName("el-form-item__error")[0]
                .scrollIntoView({
                  behavior: "smooth", //带动画效果,平滑的滚动
                  block: "center",
                });
              // });
            });
          } else {
            console.log("isOk2");
            // setTimeout(() => {
            document
              .getElementsByClassName("el-form-item__error")[0]
              .scrollIntoView({
                behavior: "smooth", //带动画效果,平滑的滚动
                block: "center",
              });
            // });
          }
        }
      }, 500);
    },
    // articleUploadDETTwo() {
    //   if (this.form.worksPublishStatus == 0) {
    //     delete this.form.worksPublishTime;
    //     delete this.form.worksPublishCountry;
    //     delete this.form.worksPublishCity;
    //     delete this.form.worksComeoutDate;
    //     delete this.form.worksComeoutCountry;
    //     delete this.form.worksComeoutCity;
    //     delete this.form.worksIssueDate;
    //     delete this.form.worksIssueCountry;
    //     delete this.form.worksIssueCity;
    //   }
    //   for (var key in this.form) {
    //     if (this.form[key] || key == 0) {
    //       this.formData.append(key, this.form[key]);
    //     }
    //   }
    //   this.formData.append("worksPublishStatus", this.form.worksPublishStatus);
    //   this.formData.append("creation", this.form.creation);
    //   this.formData.append("uniqueCode", this.contentUniqueCode);
    //   articleUploadDETTwo(this.formData).then((res) => {
    //     if (res.code == 1) {
    //       ElMessage({
    //         message: res.message,
    //         type: "success",
    //       });
    //       let json = {
    //         key: 2,
    //         isOk: true,
    //       };
    //       this.$emit("isOk", json);
    //     } else {
    //       ElMessage({
    //         message: "参数错误或不完整",
    //         type: "warning",
    //       });
    //     }
    //     this.poster = "";
    //     this.formData = new FormData();
    //   });
    // },
    uploadFilePath(e, type) {
      const loading = ElMessage({
        message: '上传中',
        type: 'warning',
        duration: 0
      })
      let files = e.target.files[0];
      const filesSize = files.size / 1024;
      if (filesSize > 2000) {
        ElMessage({
          message: "文件大小超出限制",
        });
        return false;
      }
      let json = {
        files,
        fileType: type,
        worksCode: this.contentUniqueCode,
      };
      for (let key in json) {
        this.filesData.append(key, json[key]);
      }
      uploadFilePath(this.filesData).then((res) => {
        ElMessage({
          message: res.message,
          type: "success",
        });
        this.filesData = new FormData();
        if (res.code == 1) {
          this.uploadOk = true;
          if (type == "C1") {
            this.uploadShow.C1 = true;
          } else if (type == "C2") {
            this.uploadShow.C2 = true;
          } else if (type == "C3") {
            this.uploadShow.C3 = true;
          } else if (type == "Z1") {
            this.uploadShow.Z1 = true;
          } else if (type == "C8") {
            this.uploadShow.C8 = true;
          } else if (type == "C16") {
            this.uploadShow.C16 = true;
          }
        }
      }).finally(() => {
        loading.close()
      });
    },
    inputFile(e, type) {
      const imgLoading = ElMessage({
        message: '上传中',
        type: 'warning',
        duration: 0
      })
      let files = e.target.files[0];
      if (!files.type.match(/.jpg|.png|.jpeg/i)) {
        alert("图片格式错误,请上传png/jpg/jpeg格式的图片!");
        return;
      }
      if (type == "poster") {
        this.formData.append("poster", files); //添加Fail类型的图片信息的参数
      }
      var reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        if (type == "poster") {
          this.poster = reader.result;
          imgLoading.close()
        }
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
        imgLoading.close()
      };
    },
    articleGetWorksInfo() {
      articleGetWorksInfo({
        contentUplinkCode: Cookies.get("uniqueCode"),
      }).then((res) => {
        res.data.worksAuthorList[0].postCode == 1
          ? (this.typeList[0].name = "原创")
          : (this.typeList[0].name = "社创");
        this.uploadShow.C1 = res.data.worksFilesGroupDTOList.C1;
        this.uploadShow.C2 = res.data.worksFilesGroupDTOList.C2;
        this.uploadShow.C3 = res.data.worksFilesGroupDTOList.C3;
        this.uploadShow.Z1 = res.data.worksFilesGroupDTOList.Z1;
        this.uploadShow.C8 = res.data.worksFilesGroupDTOList.C8;
        this.uploadShow.C16 = res.data.worksFilesGroupDTOList.C16;
        this.worksFilesGroupDTOList = res.data.worksFilesGroupDTOList;
        (this.poster = res.data.poster),
          (this.form.name = res.data.name),
          (this.form.type = res.data.type),
          (this.form.creation = res.data.creation),
          (this.form.worksCreateTime = res.data.worksCreateTime),
          (this.form.worksCreationCountry = res.data.worksCreationCountry),
          (this.form.worksCreationCity = res.data.worksCreationCity),
          (this.form.worksPublishStatus = res.data.worksPublishStatus),
          (this.form.worksPublishTime = res.data.worksPublishTime),
          (this.form.worksPublishCountry = res.data.worksPublishCountry),
          (this.form.worksPublishCity = res.data.worksPublishCity),
          (this.form.worksComeoutDate = res.data.worksComeoutDate),
          (this.form.worksComeoutCountry = res.data.worksComeoutCountry),
          (this.form.worksComeoutCity = res.data.worksComeoutCity),
          (this.form.worksIssueDate = res.data.worksIssueDate),
          (this.form.worksIssueCountry = res.data.worksIssueCountry),
          (this.form.worksIssueCity = res.data.worksIssueCity),
          (this.form.content = res.data.content || "请输入作品内容。。。"),
          (this.contentUniqueCode = res.data.uniqueCode);
        Cookies.set("contentUniqueCode", res.data.uniqueCode);
      });
    },
    dowmloadMth(type) {
      let href = `http://kb.qikan.cn/file/${type}.docx`;
      window.open(href, "_blank");
    },
    setContent(e) {
      this.form.content = e;
    },
    typeListClick(e) {
      this.form.creation = e.type;
    },
  },
};
</script>
<style lang="scss">
.workInformation .el-form-item__label {
  font-size: 12px;
}

.workInformation .el-form-item {
  margin-bottom: 30px;
}

.workInformation .el-form-item__error {
  position: static;
}
</style>
<style lang="scss" scope>
.workInformation {
  width: 100%;
  display: flex;
  flex-direction: column;

  .btnWap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 50px 0;

    div {
      height: 40px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;
      cursor: pointer;
    }

    div:nth-of-type(1) {
      width: 120px;
      border: 1px solid #c0c4cc;
      margin-right: 72px;
      color: #909399;
    }

    div:nth-of-type(2) {
      width: 240px;
      background: #008aea;
      color: #ffffff;
    }
  }

  .editorWap {
    width: 100%;
    margin-top: 60px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .title {
      font-size: 30px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      font-weight: 600;
      text-align: center;
    }

    .content {
      width: 100%;
      display: flex;
      justify-content: center;
      // background: #f5f7fa;
      margin: 20px 0;
    }
  }

  .itemBorderWap {
    width: 100%;
    border-top: 1px #e6e6e6 solid;
    display: flex;
    justify-content: center;

    .itemBorder {
      width: 550px;
      padding: 20px 0;
      box-sizing: border-box;

      .selectFourWap {
        display: flex;
        align-items: center;

        div {
          width: 145px;
          margin-right: 10px;
        }
      }
    }
  }

  .workInformationTop {
    width: 550px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: auto;

    .forImgWap {
      display: flex;
      align-items: flex-start;
      margin-top: 8px;

      .itemList {
        width: 160px;
        margin-right: 24px;
        position: relative;

        .downloadTemplate {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #008aea;
          text-decoration: underline;
          cursor: pointer;
        }

        .theTitle {
          font-size: 12px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
        }

        .theFont {
          margin-top: 4px;
          width: 160px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #909399;
          line-height: 16px;
        }

        .theImg {
          width: 100%;
          height: 240px;
          cursor: pointer;
          display: flex;
          align-items: center;
          position: relative;
          justify-content: center;
          overflow: hidden;

          input {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            opacity: 0;
          }

          img {
            height: 100%;
          }
        }
      }
    }

    .illustrations {
      line-height: initial;
      margin-top: 4px;

      div {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        margin-top: 4px;
      }

      div:last-of-type {
        margin-top: 24px;
      }
    }

    .aSample {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      flex-direction: column;

      .bottom {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        margin-top: 10px;
      }

      .top {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .uploadOk {
          margin-left: 10px;
        }

        .uploadWap {
          width: 102px;
          height: 40px;
          background: #008aea;
          border-radius: 8px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          text-align: center;
          position: relative;
          cursor: pointer;

          input {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
          }
        }
      }
    }

    .creativeNature {
      width: 432px;

      .textArea {
        margin-top: 10px;
      }

      .typelist {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        div {
          width: 102px;
          height: 40px;
          background: #008aea;
          border-radius: 8px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          line-height: 40px;
          text-align: center;
          margin-bottom: 10px;
          background: #f5f7fa;
          color: #008aea;
          font-weight: 700;
          cursor: pointer;
        }

        .active {
          color: #ffffff;
          background: #008aea;
        }
      }
    }

    .coverContainer {
      display: flex;
      align-items: center;

      .right_ {
        margin-left: 16px;

        div {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          line-height: initial;
        }

        div:nth-of-type(1) {
          color: #909399;
        }

        div:nth-of-type(2) {
          color: #303133;
          margin-top: 4px;
        }
      }

      .left_ {
        width: 96px;
        height: 96px;
        cursor: pointer;
        display: flex;
        align-items: center;
        position: relative;
        justify-content: center;
        overflow: hidden;

        input {
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          opacity: 0;
        }

        img {
          width: 100%;
        }
      }
    }

    .elSelectBlock {
      display: block;
    }
  }
}
</style>
